<template>
  <row-item class="product-action-row-btn"
            :type="type"
            :round="round"
            :size="size"
            :disabled="disabled"
            @click="handleClick"
  >
    <div class="product-action-row-btn-info">
      <div v-if="showPrice"
           class="price-container"
      >
        <price :price="price"
               :type="priceType"
        />
      </div>
      <div class="hint">{{ hint }}</div>
    </div>
    <div v-if="desc && desc !== ''"
         class="product-action-row-btn-desc"
    >
      {{ desc }}
    </div>
  </row-item>
</template>

<script>
  import RowItem from '@/components/YmTabbarItem/Row';
  import Price from '@/components/Price';

  export default {
    name: 'ProductDetailBottomActionRowBtn',
    components: {
      RowItem,
      Price,
    },
    props: {
      type: {
        type: String,
        default: 'gradient-primary',
        validator(val) {
          return [
            'gradient-primary',
            'black',
            'black-gold',
            'gold-black',
            'gradient-training',
            'primary',
            'gradient-gold',
          ].includes(val);
        },
      },
      hint: {
        type: String,
        required: true,
      },
      price: {
        type: [Number, String],
        required: true,
      },
      delPrice: {
        type: [Number, String],
        default: 0,
      },
      round: Boolean,
      size: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            'small',
            'normal',
            'medium',
          ].includes(val);
        },
      },
      disabled: Boolean,
      desc: {
        type: String,
      },
    },
    computed: {
      showPrice() {
        return this.price > 0;
      },
      priceType() {
        const priceTypeMap = {
          'gradient-primary': 'primary-bar',
          black: 'black',
          'gold-black': 'black',
          'black-gold': 'gold',
          'gradient-training': 'primary-bar',
          primary: 'primary-bar',
        };
        return priceTypeMap[this.type];
      },
    },
    methods: {
      handleClick() {
        const { disabled } = this;
        if (disabled) return;
        this.$emit('click');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-action-row-btn {
    &-info {
      display: flex;
      align-items: flex-end;
    }
    &-desc {
      margin-top: @size-extra-small / 2;
      color: @color-primary-lighter;
      font-size: @font-size-small;
      line-height: 1;
    }
  }

  .hint {
    font-size: @font-size-medium;
    line-height: 1.2;
  }

  .price-container {
    display: flex;
    align-items: flex-end;

    + .hint {
      margin-left: @size-small;
    }
  }

  .del-price {
    line-height: 1.2;
    margin-left: @size-extra-small;
  }
</style>
